const isPrintMode = require('ca-environment/isPrintMode').default;
import isTestMode from 'ca-environment/isTestMode';
import { setupIntercom } from '@cultureamp/intercom';

const isExcludedComponent = () => {
  const win = window as { COMPONENT?: string };
  return win.COMPONENT === 'response';
};

/* Set up Intercom on the current page if it's safe to do so.
 * Intercom will not be set up on capture pages, when printing, or during tests.
 * @return `Promise<UnknownFunction>` if Intercom was set up the promise resolves the window.Intercom function.
 * @return `Promise<false>` if Intercom was not set up the promise resolves with the avlue `false`.
 */
const filterSetupIntercom: () => Promise<false | UnknownFunction> = () => {
  if (isExcludedComponent() || isPrintMode() || isTestMode())
    return Promise.resolve(false);
  return setupIntercom();
};

export default filterSetupIntercom;
